(function ($, Drupal) {
  Drupal.behaviors.blazyInit = {
    attach: function (context, settings) {

      var bLazy = new Blazy({
        selector: '.b-lazy',
        success: function () {
          bLazy.revalidate();
        }
      });

    }
  }
})(jQuery, Drupal);
